import { Fragment } from 'react';

export const PostBody: React.FC<{
  content: (string | React.ComponentType)[];
}> = ({ content }) => {
  return (
    <div>
      {content.map((E, i) => (
        <Fragment key={i}>
          {typeof E === 'string' ? (
            <div className='post-body mx-auto'>
              <div dangerouslySetInnerHTML={{ __html: E }} />
            </div>
          ) : (
            <E />
          )}
        </Fragment>
      ))}
    </div>
  );
};
